import React from "react";
import PropTypes from "prop-types";

const TitleTextBLockCard = ({
  text,
  border = true,
  outerContainerStyle = "flex justify-center items-center border border-black-lighter dark:border-gray-quinary rounded-md p-3 bg-transparent dark:bg-generic-bg",
  innerContainerStyle = "flex justify-center items-center bg-transparent text-white h-20 w-full",
  textStyle = "text-center text-sm break-words w-2/3 text-generic-text dark:text-white"
}) => {
  return (
    <div className={outerContainerStyle}>
      <div className={innerContainerStyle}>
        <div className={textStyle}>{text}</div>
      </div>
    </div>
  );
};

TitleTextBLockCard.propTypes = {
  border: PropTypes.bool,
  outerContainerStyle: PropTypes.string,
  innerContainerStyle: PropTypes.string,
  textStyle: PropTypes.string
};

export default TitleTextBLockCard;
